import React from 'react'

import { UrlApi } from '../../services/apirest'
import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";

function Camionbuscar({ value, onChange }) {

const [camiones, setCamiones] = useState([]);
 // console.log("Camionbuscar camiones", camiones);

  useEffect(() => {
    const fetchCamiones = async () => {
      try {
        const res = await fetch(`${UrlApi}/vehiculos/patentecamion`);
        const data = await res.json();
        setCamiones(data);
      } catch (error) {
        console.error(" Error al traer camiones", error);
      }
    };
    fetchCamiones();
  }, []);


   return (
    <Autocomplete
      options={camiones}
      getOptionLabel={(option) =>
        option ? `Patente: ${option.patente}` : ""
      }
      value={camiones.find((c) => c.patente === value) || null}
      onChange={(e, newValue) => onChange(newValue ? newValue.patente : "")}
      renderInput={(params) => (
        <TextField {...params} label="Patente del camión" fullWidth />
      )}
    />
  );
}

export default Camionbuscar